// extracted by mini-css-extract-plugin
module.exports = {"root":"_2Gx4MrGc","title":"IFUjIWv2","button":"t9uapaeV"};